import { useMedia } from 'react-use';
import { lgStartMedia, mdMedia } from '../../constants';
export var ViewportSizes;
(function (ViewportSizes) {
    ViewportSizes["large"] = "large";
    ViewportSizes["medium"] = "medium";
    ViewportSizes["small"] = "small";
})(ViewportSizes || (ViewportSizes = {}));
function getMediaDefaultState(query, ssr) {
    if (ssr) {
        return false;
    }
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
        return false;
    }
    return window.matchMedia(query).matches;
}
export function useViewportBreakpoints({ ssr = true, } = {}) {
    const isLarge = useMedia(lgStartMedia, getMediaDefaultState(lgStartMedia, ssr));
    const isMedium = useMedia(mdMedia, getMediaDefaultState(mdMedia, ssr));
    return ((isLarge && ViewportSizes.large) || (isMedium && ViewportSizes.medium) || ViewportSizes.small);
}
//# sourceMappingURL=useViewportBreakpoints.js.map